import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreDataService } from '@app/core/async-services/http/core.data';
import { API } from '@app/core/models';
import { VersionConfigService } from '@app/core/services/version-config';

@Injectable({
  providedIn: 'root',
})
export class SecureDataHttpService {
  private _urlPrefix = '';
  private _options: API.HttpOptions;

  constructor(
    private _coreDataService: CoreDataService,
    private _versionConfigService: VersionConfigService,
  ) {
    this._versionConfigService.getVersion('secureData').subscribe((prefix) => {
      this._urlPrefix = `${prefix}/secure-data/`;
    });
    this._options = this._coreDataService.getHttpOptions();
  }

  getTeamWellnessCheckInRisks(
    entId: string,
    publicKey: string,
  ): Observable<API.EncryptedResponse> {
    const encodedEntId = encodeURIComponent(entId);
    const encodedPublicKey = encodeURIComponent(publicKey);

    return this._coreDataService.get<API.EncryptedResponse>(
      `${this._urlPrefix}wellness-risk/${encodedEntId}/${encodedPublicKey}`,
      this._options,
    );
  }
}
